import { render } from "./EmbedView.vue?vue&type=template&id=d50ee7d8&scoped=true"
import script from "./EmbedView.vue?vue&type=script&lang=js"
export * from "./EmbedView.vue?vue&type=script&lang=js"

import "./EmbedView.vue?vue&type=style&index=0&id=d50ee7d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d50ee7d8"]])

export default __exports__